import { defineStore } from 'pinia'
import { getLocalState, setLocalState } from './helper'

export const useFavoritesStore = defineStore('favorites-store', {
  state: (): Favorites.FavoritesState => getLocalState(),

  getters: {
    getFavorites: state => state.favorites,
    getLoading: state => state.loading,
    getPagination: state => state.pagination,
    getFavoriteById: state => (id: string | number) => {
      return id ? state.favorites.find(favorite => favorite.id === id) : null
    },
    isFavorite: state => (id: string | number) => {
      return state.favorites.some(favorite => favorite.id === id)
    },
  },

  actions: {
    setLoading(loading: boolean) {
      this.loading = loading
      this.recordState()
    },

    setFavorites(favorites: Favorites.FavoritesItem[]) {
      this.favorites = favorites
      this.recordState()
    },

    setPagination(pagination: Favorites.FavoritesState['pagination']) {
      this.pagination = pagination
      this.recordState()
    },

    addFavorite(favorite: Favorites.FavoritesItem) {
      const existingIndex = this.favorites.findIndex(item => item.id === favorite.id)
      if (existingIndex === -1) {
        this.favorites.unshift(favorite)
        this.recordState()
      }
    },

    removeFavorite(id: string | number) {
      const index = this.favorites.findIndex(item => item.id === id)
      if (index !== -1) {
        this.favorites.splice(index, 1)
        this.recordState()
      }
    },

    toggleFavorite(favorite: Favorites.FavoritesItem) {
      const existingIndex = this.favorites.findIndex(item => item.id === favorite.id)

      if (existingIndex !== -1)
        this.favorites.splice(existingIndex, 1)
      else
        this.favorites.unshift(favorite)

      this.recordState()
    },

    clearFavorites() {
      this.favorites = []
      this.recordState()
    },

    recordState() {
      setLocalState(this.$state)
    },
  },
})
